<template>
    <div>
        <div style="width: 100%;margin-bottom: 60px;margin-top: 20px;">
            <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4f6df0ef67.png" style="width: 100%;" alt="">
        </div>
        <div class="companyInfo">
            <div class="titles">公司介绍</div>
            <div class="infos">临里好（杭州）科技有限公司，位于杭州，公司创立于2021年。是一款为家政企业提供安全、便捷的经营管理系统及数据保全服务的产品。我们致力于打造引领中国家政行业的尖端SaaS平台，以科技创新驱动家政企业的数字化变革与升级。我们以最高标准自我鞭策，旨在推动行业规范化发展，塑造卓越品牌。怀揣着“深耕家政领域、助力百万企业、成就千万阿姨”的崇高使命，我们砥砺前行，永不止步！</div>
        </div>
        <div class="info2">
            <div style="text-align: center;" class="font_size_28">
                企业文化
            </div>
            <div class="infoBg">
                <div class="infoLeft">
                    <div class="font1">公司愿景</div>
                    <div class="font2">打造行业最智能的SaaS工具，赋能家政企业降本增效</div>
                    <div class="font1">公司愿景</div>
                    <div class="font2">科技赋能家政，服务连接美好</div>
                    <div class="font1">公司价值观</div>
                    <div class="font2">客户价值第一 诚信为本 简单务实 开放共赢 创新驱动</div>
                </div>
                <div class="infoRight">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4fe0d62259.png" style="width: 26em;" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Main',
        data() {
            return {

            }
        },
        methods: {},
        mounted() {

        },
        computed: {

        },
    }
</script>

<style scoped>
.companyInfo{background-image: url('https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4fdbc8c411.png');background-repeat: no-repeat;background-size: 100% 100%;width: 100%;padding: 60px 120px;box-sizing: border-box;color: #fff;}
.titles{text-align: center;font-size: 2em;font-weight: bold;margin-bottom: 30px;}
.infos{font-size: 1.4em;margin-bottom: 100px;}
.font_size_28{font-size: 2.2em;font-weight: normal;color: #333;margin: 50px 0;}
.infoBg{background: #EDF4FF;padding: 100px 160px;box-sizing: border-box;display: flex;align-items: center;justify-content: space-around;}
.font1{font-size: 1.7em;color: #4C4C4C;font-weight: bold;}
.font2{font-size: 1.2em;color: #4C4C4C;margin-bottom: 60px;font-weight: 400;}
</style>